import support from "../Assets/svg/menu/training.svg";
import tickets from "../Assets/svg/menu/tickets.svg";

export const SupportMenuItems = [
  {
    id: 2,
    menu_title: "training",
    menu_icon: support,
    path: "/dashboard/support/training",
    active: true,
  },
  {
    id: 1,
    menu_title: "tickets",
    menu_icon: tickets,
    path: "/dashboard/support/tickets",
    active: true,
  },
];
